<template>
  <textarea
    v-model="value"
    class="max-h-80 min-h-20 w-full rounded-r2 py-spacing_7 outline-none outline-offset-0"
    :placeholder="placeholder"
    :disabled="disabled"
    :error="`${error}`"
  />
</template>

<script setup lang="ts">
import type { TextAreaProps } from "~/types/schemas/common/Atom/textArea";

const value = defineModel<string>();

defineProps<TextAreaProps>();
</script>

<style scoped>
textarea {
  @apply border border-neutral-300 bg-neutral-100 px-spacing_9 font-primary text-size_4 font-medium text-neutral-900;

  &:focus {
    @apply outline-1 outline-primary-500;
  }

  &:disabled {
    @apply cursor-not-allowed bg-neutral-200 text-neutral-200;
  }

  &::placeholder {
    @apply text-neutral-600;
  }
}

textarea[error="true"] {
  @apply outline-1 outline-errors;
}
</style>
